import React, { ComponentType, createContext, useEffect, useState } from 'react'

const GOOGLE_MAP_SECRET_KEY = import.meta.env.VITE_GOOGLE_MAP_SECRET_KEY
const GmapsAutoCompleteServiceContext = createContext<
  google.maps.places.AutocompleteService | undefined
>(undefined)

export const withGmapsAutoCompleteService: <P>(Component: ComponentType<P>) => React.FC<P> = (
  Component
) => (props) => {
  const [autoCompleteService, setAutoCompleteService] = useState<
    google.maps.places.AutocompleteService | undefined
  >(undefined)
  const loaded = React.useRef(false)

  useEffect(() => {
    if (loaded.current) {
      return undefined
    }

    if (!document.querySelector('#google-maps')) {
      const script = document.createElement('script')
      script.setAttribute('async', '')
      script.setAttribute('id', 'google-maps')
      script.src = `https://maps.googleapis.com/maps/api/js?libraries=places&key=${GOOGLE_MAP_SECRET_KEY}`
      document.querySelector('head')?.appendChild(script)

      script.addEventListener('load', () => {
        setAutoCompleteService(new window.google.maps.places.AutocompleteService())
      })

      loaded.current = true
    } else if (window.google) {
      setAutoCompleteService(new window.google.maps.places.AutocompleteService())
    }
  }, [loaded])

  return (
    <GmapsAutoCompleteServiceContext.Provider value={autoCompleteService}>
      <Component {...props} />
    </GmapsAutoCompleteServiceContext.Provider>
  )
}

export default GmapsAutoCompleteServiceContext
